<ng-template #template>
    <div class="modal-body position-relative pt-12">
        <div class="text-dark-75 h2 mb-10 ml-25">{{ message }}
            <button type="button" class="close" (click)="cancel()"><i aria-hidden="true" class="ki ki-close"></i></button>
        </div>
        <div class="text-dark-50 mb-10 ml-25">
            {{ submessage }}
        </div>
        <ng-content></ng-content>
        <div class="d-flex">
            <button class="btn btn-outline-danger rounded-0 w-50 mx-6" (click)="cancel()">
                No
            </button><button class="btn btn-primary rounded-0 w-50 mx-6" (click)="yes()">Yes</button>
        </div>
        <span class="position-absolute" style="top: 1rem; left: -4rem;">
            <img *ngIf="modalType === 1" src="../../../.././../assets/common/images/modalpopup/Group 147527.svg" style="width: 8rem;">
            
        </span>
    </div>
</ng-template>

